import { ComponentChildren } from 'preact';
import styles from './Heading.module.css';

interface HeadingProps {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  variant?: 'xl' | 'lg' | 'md' | 'sm';
  children: ComponentChildren;
  className?: string;
  truncate?: boolean;
  underline?: boolean;
}

export function Heading({
  as: Tag = 'h2',
  variant = 'md',
  children,
  className = '',
  truncate = false,
  underline = false,
}: HeadingProps) {
  const combinedClasses = [
    styles.heading,
    styles[variant],
    truncate ? styles.truncate : '',
    className,
    underline ? styles.underline : '',
  ]
    .filter(Boolean)
    .join(' ');

  return <Tag className={combinedClasses}>{children}</Tag>;
}
